import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api'
import type { ScrollRestorationPageConfig } from '../types'
import { name } from '../symbols'

const scrollRestorationPageConfig: PageConfigFn<ScrollRestorationPageConfig> = (
	{ api, activeFeatures }: VsmContext,
	pageId: string
) => {
	const pageData = api.page.getPageData(pageId)
	const isPopupPage = pageData ? api.page.isPopup(pageData) : false
	const shouldLoadPageFeature = !isPopupPage

	if (!shouldLoadPageFeature) {
		return { shouldLoadPageFeature: false }
	}

	const isMasterPage = pageId === 'masterPage'
	const shouldRestoreScrollPosition = !isMasterPage && !activeFeatures.isActive('pageTransitions')

	return {
		shouldLoadPageFeature: true,
		pageConfig: {
			shouldRestoreScrollPosition,
		},
	}
}

export const pageConfig: PageConfigEntry<ScrollRestorationPageConfig> = {
	name,
	configFactory: scrollRestorationPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
